export enum PubSubTopics {
    ORDER_PLACED = 'order-placed',
    ORDER_CONFIRMED = 'order-confirmed',
    ORDER_PROCESSING = 'order-processing',
    ORDER_PROCESSED = 'order-processed',
    ORDER_SHIPPED = 'order-shipped',
    ORDER_DELIVERED = 'order-delivered',
    ORDER_COMPLETED = 'order-completed',
    ORDER_CANCELLED = 'order-cancelled',
    PAYMENT_PAID = 'payment-paid',
    NOTIFICATION_CREATED = 'notification-created',
    CONTACT_FORM_SUBMITTED = 'contact-form-submitted',
  }